/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const FormUnit = (props) => {
  const history = useHistory();
	const [zPos, setZPos] = useState(45);
  const [disabled, setDisabled] = useState(true);
  const [uuid, setUuid] = useState("");
  const [form, setForm] = useState({ name: "", uuid: "" });
  const [errs, setErrs] = useState({ name: "" });

  useEffect(() => {
    init();
  }, []);

  const init = () => {
    if (props.contentModal.unit) {
      let unitInfo = props.contentModal.unit;
      let f = form;
      let er = errs;

      if (unitInfo.name) {
        f.name = unitInfo.name;
      }

      verifyForm(f, er);
      setUuid(unitInfo.uuid);
      setForm(JSON.parse(JSON.stringify(f)));
    }
  };

  const verifyForm = (data, e) => {
    if (data.name && !e.name) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const change = async (field, e) => {
    let f = form;
    let er = errs;
    f[field] = e.target.value;

    verifyForm(f, er);
    setErrs(JSON.parse(JSON.stringify(er)));
    setForm(JSON.parse(JSON.stringify(f)));
  };

  const create = async () => {
    let f = form;
    let data = {
      name: f.name,
    };

    props.changeLoader(true);
		setZPos(-1);

    if (!uuid) {

      let response = await API.service( "createUnit", data, props.pos, props.changeAlert, props.changeLoader, history );
      if (response.status === 200) {
        if (response.data.data.response == "OK") {
          props.changeAlert(true, "success", "Grupo creado con éxito");
          await props.reloadData({});
          closelightbox();
        } else {
          //props.changeAlert(true, 'error', 'Error al crear Cliente.');
        }
      }
    }

    if (uuid) {
      let send = {
        uuid: uuid,
        body: data,
      };

      let response = await API.service( "updateUnit", send, props.pos, props.changeAlert, props.changeLoader, history );
      if (response.status === 200) {
        if (response.data.data.response == "OK") {
          props.changeAlert(true, "success", "Grupo modificado con éxito");
          await props.reloadData({});
          closelightbox();
        } else {
          //props.changeAlert(true, 'error', 'Error al crear Cliente.');
        }
      }
    }
    props.changeLoader(false);
		setZPos(45);
  };

  return (
		<Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
			<ModalStyle property={String(disabled)}>
				<DialogTitle >
					{uuid ? "Editar grupo" : "Crear Nuevo grupo"}
					<IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
				</DialogTitle>				
			
				<DialogContent>
					<Grid container spacing={2}>
						<Grid item xs={12} style={{fontWeight: "bolder"}}>
							Datos del grupo      
						</Grid>
						<Grid item xs={12}>
							<TextField label="Nombre del grupo" value={form.name} onChange={change.bind(this, "name")} error={errs.name !== ""} helperText={errs.name === "" ? errs.name : ''} size="small" fullWidth/>
						</Grid>					    
					</Grid>
				</DialogContent>

				<DialogActions>    
					<Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
					<Button disabled={disabled} variant="contained" onClick={create.bind(this)}>{uuid ? "Editar grupo" : "Crear grupo"}</Button>
				</DialogActions>
			</ModalStyle>
		</Dialog> 
  );
};

export default FormUnit;
